import { render, staticRenderFns } from "./DataPermTypeSelect.vue?vue&type=template&id=3fb06ec7&scoped=true&"
import script from "./DataPermTypeSelect.vue?vue&type=script&lang=js&"
export * from "./DataPermTypeSelect.vue?vue&type=script&lang=js&"
import style0 from "./DataPermTypeSelect.vue?vue&type=style&index=0&id=3fb06ec7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb06ec7",
  null
  
)

export default component.exports